/**
 * The starter ship. Generated — do not edit.
 *
 * Source: `starter.ship.json`, exported from the ship editor.
 * Regenerate with `node scripts/generate-starter.mjs`.
 *
 * 7 joints, 8 lines (33.53u of line), 7 parts:
 * 1x engine, 1x pilotSeat, 1x vault, 2x landingGear, 1x thrusterSmall, 1x thruster.
 */
export const STARTER_NAME = "StarterShip";
/** Frozen, so nothing downstream can write damage into the template itself. */
export const STARTER_GRAPH = {
    "joints": [
        {
            "id": "j-17_-1",
            "x": -4.25,
            "y": -0.25
        },
        {
            "id": "j9_-1",
            "x": 2.25,
            "y": -0.25
        },
        {
            "id": "j9_-6",
            "x": 2.25,
            "y": -1.5
        },
        {
            "id": "j-15_18",
            "x": -3.75,
            "y": 4.5
        },
        {
            "id": "j-4_30",
            "x": -1,
            "y": 7.5
        },
        {
            "id": "j4_30",
            "x": 1,
            "y": 7.5
        },
        {
            "id": "j10_23",
            "x": 2.5,
            "y": 5.75
        }
    ],
    "lines": [
        {
            "id": "l1785845797212_0",
            "a": "j-17_-1",
            "b": "j9_-1",
            "length": 6.5,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        },
        {
            "id": "l1785845806870_0",
            "a": "j-17_-1",
            "b": "j9_-6",
            "length": 6.619101147436863,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        },
        {
            "id": "l1785845808871_0",
            "a": "j9_-6",
            "b": "j9_-1",
            "length": 1.25,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        },
        {
            "id": "l1785845814815_0",
            "a": "j-17_-1",
            "b": "j-15_18",
            "length": 4.7762432936357,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        },
        {
            "id": "l1785845817604_0",
            "a": "j-15_18",
            "b": "j-4_30",
            "length": 4.0697051490249265,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        },
        {
            "id": "l1785845823168_0",
            "a": "j-4_30",
            "b": "j4_30",
            "length": 2,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        },
        {
            "id": "l1785845824493_0",
            "a": "j4_30",
            "b": "j10_23",
            "length": 2.3048861143232218,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        },
        {
            "id": "l1785845827572_0",
            "a": "j10_23",
            "b": "j9_-1",
            "length": 6.005206074732157,
            "health": 100,
            "strength": 1,
            "color": "#ffffff"
        }
    ],
    "components": [
        {
            "id": "c1785812478526",
            "type": "engine",
            "position": {
                "x": 0,
                "y": 1.75
            },
            "facing": 0,
            "mirrored": false
        },
        {
            "id": "c1785845693099",
            "type": "pilotSeat",
            "position": {
                "x": 0,
                "y": 5.5
            },
            "facing": 0
        },
        {
            "id": "c1785845710809",
            "type": "vault",
            "position": {
                "x": -3,
                "y": 1
            },
            "facing": 0
        },
        {
            "id": "c1785845716301",
            "type": "landingGear",
            "position": {
                "x": -2.5,
                "y": 3.25
            },
            "facing": 0
        },
        {
            "id": "c1785845720652",
            "type": "landingGear",
            "position": {
                "x": 1.75,
                "y": 4.75
            },
            "facing": 0
        },
        {
            "id": "c1785845753416",
            "type": "thrusterSmall",
            "position": {
                "x": -2.25,
                "y": -1
            },
            "facing": 0
        },
        {
            "id": "c1785845777690",
            "type": "thruster",
            "position": {
                "x": 0.75,
                "y": -1.5
            },
            "facing": 0
        }
    ]
};
//# sourceMappingURL=starter.generated.js.map